import React from "react";

import {
  buildNote,
  getAckInfo,
  getDisplayTime,
  normalizeTypeLabel,
  typeBadgeClass,
} from "../../utils/eventUtils";
import AckCell from "./AckCell";

export default function EventTable({ logs, onWatchClip }) {
  return (
    <div className="hidden overflow-hidden rounded-[22px] border border-gray-200 dark:border-white/10 md:block">
      <div className="overflow-x-auto">
        <table className="min-w-[920px] w-full border-collapse">
          <thead className="bg-gray-50 dark:bg-[#0F172A]">
            <tr className="text-left text-xs text-gray-500 dark:text-gray-400">
              <th className="px-4 py-4 font-semibold">시간</th>
              <th className="px-4 py-4 font-semibold">타입</th>
              <th className="px-4 py-4 font-semibold">장비명</th>
              <th className="px-4 py-4 font-semibold">내용</th>
              <th className="px-4 py-4 font-semibold">비고</th>
              <th className="px-4 py-4 text-center font-semibold">처리</th>
              <th className="px-4 py-4 font-semibold">사진</th>
            </tr>
          </thead>

          <tbody>
            {logs.length === 0 ? (
              <tr>
                <td
                  colSpan={7}
                  className="px-4 py-12 text-center text-sm text-gray-500 dark:text-gray-400"
                >
                  표시할 이벤트가 없습니다.
                </td>
              </tr>
            ) : (
              logs.map((row, idx) => (
                <tr
                  key={`${row?.eventType || "EV"}_${row?.deviceId || "NOID"}_${
                    row?._timeMs || idx
                  }_${idx}`}
                  className="border-t border-gray-100 text-sm dark:border-white/5"
                >
                  <td className="whitespace-nowrap px-4 py-4 text-gray-600 dark:text-gray-300">
                    {getDisplayTime(row)}
                  </td>

                  <td className="px-4 py-4">
                    <span
                      className={`inline-flex whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold ${typeBadgeClass(
                        row
                      )}`}
                    >
                      {normalizeTypeLabel(row)}
                    </span>
                  </td>

                  <td className="whitespace-nowrap px-4 py-4 text-gray-800 dark:text-gray-100">
                    {row?.deviceName || row?.deviceId || "-"}
                  </td>

                  <td className="px-4 py-4 text-gray-700 dark:text-gray-200">
                    <div className="min-w-[220px] break-words">
                      {row?.message || "-"}
                    </div>
                  </td>

                  <td className="px-4 py-4 text-gray-500 dark:text-gray-400">
                    <div className="min-w-[180px] break-words">
                      {buildNote(row)}
                    </div>
                  </td>

                  <td className="whitespace-nowrap px-4 py-4 text-center">
                    <AckCell ack={getAckInfo(row)} />
                  </td>

                  <td className="px-4 py-4">
                    {String(row?.eventType || "").toUpperCase() ===
                      "PPE_VIOLATION" && (
                      <button
                        type="button"
                        onClick={() => onWatchClip?.(row)}
                        className="whitespace-nowrap rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-blue-700"
                      >
                        캡처 보기
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}